import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ValidTokenRouteGuardService } from 'src/app/modules/authentication/services/valid-token-route-guard.service';

import { TemplateListComponent } from './pages/templates/template-list/template-list.component';
import { TemplateEditComponent } from './pages/templates/template-edit/template-edit.component';

import { ChannelListComponent } from './pages/channels/channel-list/channel-list.component';
import { DistributionListComponent } from './pages/distribution-lists/distribution-list/distribution-list.component';
import { DistributionListEditComponent } from './pages/distribution-lists/distribution-list-edit/distribution-list-edit.component';
import { WorkflowListComponent } from './pages/workflow/workflow-list/workflow-list.component';
import { WorkflowEditComponent } from './pages/workflow/workflow-edit/workflow-edit.component';
import { NotificationListComponent } from './pages/notifications/notification-list/notification-list.component';
import { AppPageComponent } from '@app/core/layout/app-page/app-page.component';
import { CommunicationsRouteConfigResolver, DistributionListResolver } from './resolvers';

const routes: Routes = [
  {
    path: '',
    component: AppPageComponent,
    resolve: { routeConfig: CommunicationsRouteConfigResolver },
    children: [
      {
        path: '',
        redirectTo: 'notifications',
        pathMatch: 'full'
      },
      {
        path: 'channels',
        component: ChannelListComponent,
        canActivate: [ValidTokenRouteGuardService]
      },
      {
        path: 'channels/:id',
        component: ChannelListComponent,
        canActivate: [ValidTokenRouteGuardService]
      },
      {
        path: 'distribution-lists/:id',
        component: DistributionListEditComponent,
        canActivate: [ValidTokenRouteGuardService],
        resolve: { distributionList: DistributionListResolver }
      },
      {
        path: 'distribution-lists',
        component: DistributionListComponent,
        canActivate: [ValidTokenRouteGuardService]
      },
      {
        path: 'templates/:id',
        component: TemplateEditComponent,
        canActivate: [ValidTokenRouteGuardService]
      },
      {
        path: 'templates',
        component: TemplateListComponent,
        canActivate: [ValidTokenRouteGuardService]
      },
      {
        path: 'notifications',
        component: NotificationListComponent,
        canActivate: [ValidTokenRouteGuardService]
      },
      {
        path: 'workflows/:id',
        component: WorkflowEditComponent,
        canActivate: [ValidTokenRouteGuardService]
      },
      {
        path: 'workflows',
        component: WorkflowListComponent,
        canActivate: [ValidTokenRouteGuardService]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommunicationsRoutingModule {}
